module.exports = __webpack_public_path__ + "static/media/calendar-red.21baf016.svg";